<template>
  <Modal :id="id" title="Confirm/Reject Event Request" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12 mb-3">
          <div class="details-pane-table">
            <div class="row mb-2">
              <div class="col-4 col-attribute">Course:</div>
              <div class="col-8 col-value">{{ event.name }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-4 col-attribute">Event ID:</div>
              <div class="col-8 col-value">{{ event.id }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-4 col-attribute">Date/Time:</div>
              <div class="col-8 col-value" v-html="event.dateAndTime"></div>
            </div>
            <div class="row mb-2">
              <div class="col-4 col-attribute">Location:</div>
              <div v-if="isVirtual" class="col-8 col-value">Virtual</div>
              <div v-else class="col-8 col-value" v-html="event.address"></div>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <Field
            type="select"
            name="rsvp"
            label="Your RSVP"
            v-model="rsvp"
            :options="rsvpOptions"
            :hide-select-empty-option="true"
          />
        </div>
        <div v-if="showRsvpNotes" class="col-12">
          <Field
            type="textarea"
            name="rsvp_notes"
            label="Reason"
            v-model="rsvpNotes"
          />
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Save</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "trainer-rsvp-modal",
      event: null,
      rsvp: null,
      rsvpNotes: null,
    };
  },
  computed: {
    isVirtual() {
      return !!this.event.course && !!this.event.course.is_virtual;
    },
    rsvpOptions() {
      return [
        {
          value: this.$root.constants.TRAINER_RSVP_CONFIRM,
          label: "Confirmed",
        },
        {
          value: this.$root.constants.TRAINER_RSVP_CHANGES,
          label: "Confirmed with changes",
        },
        {
          value: this.$root.constants.TRAINER_RSVP_REJECT,
          label: "Rejected",
        },
      ];
    },
    showRsvpNotes() {
      return (
        this.rsvp === this.$root.constants.TRAINER_RSVP_CHANGES ||
        this.rsvp === this.$root.constants.TRAINER_RSVP_REJECT
      );
    },
  },
  methods: {
    save() {
      if (!this.rsvp) {
        alert("Please choose an RSVP option");
        return;
      }
      let url = this.route("profile.calendar.rsvp", { event: this.event.id });
      this.axios
        .post(url, {
          rsvp: this.rsvp,
          rsvp_notes: this.rsvpNotes,
        })
        .then(() => {
          this.resolve();
        });
    },
  },
  created() {
    this.event = this.options.event;
  },
};
</script>